/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HolidaysData
 */
export interface HolidaysData {
    /**
     * 
     * @type {string}
     * @memberof HolidaysData
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof HolidaysData
     */
    name?: string;
}

/**
 * Check if a given object implements the HolidaysData interface.
 */
export function instanceOfHolidaysData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HolidaysDataFromJSON(json: any): HolidaysData {
    return HolidaysDataFromJSONTyped(json, false);
}

export function HolidaysDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HolidaysData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : json['date'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function HolidaysDataToJSON(value?: HolidaysData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'name': value.name,
    };
}

